import React from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './page.component.module.styl';

import type {ComponentProps, ReactNode} from 'react';

const classNames = withCssModule(styles);

type Props = {
    /**
     * Search bar component(s) rendered inside the `page__search` region of the
     * `<PageHeader>` (e.g. an autosuggest or input field).
     */
    children: ReactNode,
} & ComponentProps<'div'>;

/**
 * Search bar slot inside a `<PageHeader>`.
 *
 * Renders a `<div>` with the `page__search` layout class. Place an autosuggest,
 * input, or any search UI component as `children`.
 */
export const PageSearch = (props: Props) => {
    const classes = classNames('page__search', props?.className);

    return (
        <div {...props} className={classes}>
            {props.children}
        </div>
    );
};

PageSearch.displayName = 'PageSearch';
